import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EmailISRead } from 'src/app/communications/models/emails/email-is-read';
import { EmailToThreadDto } from 'src/app/communications/models/emails/email-to-thred-dto';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsService {
  private openThread = new Subject<EmailToThreadDto>();
  onOpenThread$ = this.openThread.asObservable();
  private IsreadUnreadThread = new Subject<EmailISRead>();
  IsreadUnreadThread$ = this.IsreadUnreadThread.asObservable();
  private IsreadUnreadInbox = new Subject<EmailISRead>();
  IsreadUnreadInbox$ = this.IsreadUnreadInbox.asObservable();

  private settingsUpdatedSource = new Subject<boolean>();
  settingsUpdated$ = this.settingsUpdatedSource.asObservable();

  constructor() {}

  setOpenThread(value: EmailToThreadDto) {
    if (!value) return;
    this.openThread.next(value);
  }
  setIsReadUnread(value: EmailISRead) {
    if (!value) return;
    this.IsreadUnreadThread.next(value);
  }
  setIsReadUnreadForInbox(value: EmailISRead) {
    if (!value) return;
    this.IsreadUnreadInbox.next(value);
  }
 
  invalidateOpenThread() {
    this.openThread.next(new EmailToThreadDto());
  }

  notifyRecommendationUpdated(isSuccess: boolean) {
    this.settingsUpdatedSource.next(isSuccess);
  }
}
